module.exports = {"150725100":"陈旗巴彦库仁镇","150725101":"陈旗宝日希勒镇","150725102":"陈旗呼和诺尔镇","150725200":"陈旗西乌珠尔苏木","150725201":"陈旗鄂温克民族苏木","150725202":"陈旗东乌珠尔苏木","150725203":"陈旗巴彦哈达苏木","150725501":"陈巴尔虎旗国营哈图达牧场","150725502":"陈旗国营浩特陶海农牧场","150725503":"陈旗国营特泥河牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150725.json
// module id = 451
// module chunks = 0